import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
/* eslint-disable import/no-extraneous-dependencies */
import HelpLinkContainer from 'app/components/shared/HelpLink/HelpLinkContainer';
/* eslint-enable import/no-extraneous-dependencies */
import '../styles/DigitalNotificationEmail.scss';

export function DigitalNotificationEmail({ onChange, value }) {
  return (
    <label className="cp-digital-notification-email" htmlFor="digital-notification">
      <FormattedMessage id="digital_hold_digital_notification_email" />
      <HelpLinkContainer page="045faq/025faq-downloadable/#dne">
        <ScreenReaderMessage>
          <FormattedMessage id="ada_digital_notification_email" />
        </ScreenReaderMessage>
      </HelpLinkContainer>
      <input
        type="email"
        id="digital-notification"
        className="form-control"
        onChange={onChange}
        value={value}
        required
      />
    </label>
  );
}

DigitalNotificationEmail.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default DigitalNotificationEmail;
